<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>运输费用申请使用说明:<br>
					<span>1、单号构成规则:201201+YF+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交主单据给财务经理进行费用申请审核</span><br>
					<span>3、业务说明:运输费用申请(单条多明细)=>部门经理审核(可跳过)=>财务核对=>经理审核=>财务打款=>数据归档</span><br>
					<span class="red">4、如果是发货,申请费用就是支出费用。</span><br>
					<span class="red">5、如果是非发货,申请费用就是期初费用,司机报销是对应支出。</span><br>
					<span>6、查询关键字:单号、运输单号、厂家、车牌、状态、收款人。</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->

		</pre-base>
	</div>
</template>

<script>
	
	
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue"),
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',
				// 下拉菜单
				// list_fee: [],
				// sel_fee: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init:  function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '运输费用申请',
					"control": "transapply",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_ys_tr_apply_fh',
					"upd_action": 'exp15_ys_tr_apply',
					"detail_part": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_tr2_apply',
					"d_upd_action": '_ys_tr2_apply',
					
					"file_action": 'file',
					"p1": 'apply',
					"p2": 'apply',
					"p3": '',
					"parm_sel": [
						{
							"name": "申请单",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1-2",
							"sel": "1"
						},
						{
							"name": "运单号",
							"val": "",
							"key": "order_no",
							"type": "text",
							"class": "long1-2",
							"sel": "2"
						},
						{
							"name": "厂家",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "5"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "rec_user",
							"type": "text",
							"class": "long1",
							"sel": "6"
						}
					],
					"parm": [
						{
							"name": "申请单",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1-2",
							"p": "1",
							"w":"0",
							"r":"1",
							"x":"1"
						},
						{
							"name": "运单号",
							"val": "",
							"key": "order_no",
							"type": "text",
							"class": "long1-2",
							"p": "1",
							"w":"1",
							"r":"0",
							"x":"1"
						},
						{
							"name": "剩余里程",
							"val": "",
							"key": "d_now",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"r":"0",
							"x":"1"
						},						
						{
							"name": "收款人",
							"val": "",
							"key": "rec_user",
							"type": "text",
							"class": "long1-2",
							"p": "1",
							"w":"0",
							"r":"0",
							"x":"2"
						},
						{
							"name": "收款账号",
							"val": "",
							"key": "rec_card",
							"type": "text",
							"class": "long1-2",
							"p": "1",
							"w":"0",
							"r":"0",
							"x":"2"
						}, 
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w":"0",
							"r":"0",
							"x":"2"
						},
						{
							"name": "调度信息",
							"val": "",
							"key": "sheet_note",
							"type": "textarea",
							"class": "long5",
							"p": "0",
							"w":"0",
							"r":"1",
							"x":"3"
						},
						// {
						// 	"name": "总运费",
						// 	"val": "",
						// 	"key": "amount_all",
						// 	"type": "label",
						// 	"class": "black",
						// 	"p": "0",
						// 	"w":"0",
						// 	"r":"1",
						// 	"x":"4"
						// },
						// {
						// 	"name": "运费",
						// 	"val": "",
						// 	"key": "amount_y",
						// 	"type": "label",
						// 	"class": "black",
						// 	"p": "0",
						// 	"w":"0",
						// 	"r":"1",
						// 	"x":"4"
						// },
						// {
						// 	"name": "现金",
						// 	"val": "",
						// 	"key": "amount_xj",
						// 	"type": "label",
						// 	"class": "black",
						// 	"p": "0",
						// 	"w":"0",
						// 	"r":"1",
						// 	"x":"4"
						// },
						// {
						// 	"name": "未付油",
						// 	"val": "",
						// 	"key": "amount_no_y",
						// 	"type": "label",
						// 	"class": "black",
						// 	"p": "0",
						// 	"w":"0",
						// 	"r":"1",
						// 	"x":"4"
						// },
						// {
						// 	"name": "未付现金",
						// 	"val": "",
						// 	"key": "amount_no_xj",
						// 	"type": "label",
						// 	"class": "black",
						// 	"p": "0",
						// 	"w":"0",
						// 	"r":"1",
						// 	"x":"4"
						// }
						
					],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "申请单"
						},
						{
							"name": "运单号"
						},
						{
							"name": "状态"
						},
						{
							"name": "车牌"
						},
						{
							"name": "司机",
							"class": "short0"
						},
						{
							"name": "调度信息"
						},
						// {
						// 	"name": "跟车员",
						// 	"class": "short0"
						// },
						// {
						// 	"name": "厂家"
						// },
						// {
						// 	"name": "货名"
						// },
						// {
						// 	"name": "装货地点"
						// },
						// {
						// 	"name": "卸货地点"
						// },
						// {
						// 	"name": "总里程"
						// },
						{
							"name": "剩余里程"
						},
						{
							"name": "申请金额"
						},
						{
							"name": "收款人"
						},
						{
							"name": "收款账号",
							"class": "long2"
						},
						{
							"name": "申请人备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						// {
						// 	"name": "总运费",
						// 	"class": "short0"
						// },						
						// {
						// 	"name": "已付现金",
						// 	"class": "short0"
						// },
						// {
						// 	"name": "已付油",
						// 	"class": "short0"
						// },
						// {
						// 	"name": "未付现金",
						// 	"class": "short0"
						// },
						
						// {
						// 	"name": "未付油",
						// 	"class": "short0"
						// },
						{
							"name": "申请人",
							"class": "short0"
						},
						// {
						//   "name": "申请人更新状态"
						// },
						{
							"name": "申请人更新时间"
						},
						// {
						// 	"name": "审核人",
						// 	"class": "short0"
						// },
						// {
						// 	"name": "审核人更新时间"
						// },
						{
							"name": "附件1"
						},
						{
							"name": "附件2"
						},
						{
							"name": "更新时间",
							"class": "long2"
						}
					],
					"d_parm": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"w": "0",
							"p": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "f_name",
							"type": "select",
							"sel_action":"_base_pay_yf",
							"sel_name": "",
							"class": "long1",
							"p": "1",
							"w": "1"
						},
						{
							"name": "申请金额",
							"val": "",
							"key": "amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1"
						},
						{
							"name": "支付日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
						},
						{
							"name": "油卡卡号",
							"val": "",
							"key": "pay_no",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
						},
						{
							"name": "是否开票",
							"val": "",
							"key": "is_paper",
							"type": "select",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "公司支付",
							"val": "否",
							"key": "is_pay",
							"type": "select",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "申请金额"
						},
						// {
						// 	"name": "当前余额"
						// },
						{
							"name": "支付日期"
						},
						{
							"name": "油卡卡号"
						},
						{
							"name": "是否开票"
						},
						{
							"name": "是否支付"
						},
						{
							"name": "备注"
						}
					]
				});



			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}
			
			




		}
	};
</script>
<style>
</style>
